module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-1-KVND.a139c77ds.png";